import { Edge, Node } from '@xyflow/react';
import { GlobalSettingsType } from 'src/context/global/types';
import { IEdgeExtraData } from 'src/modules/network-configuration/edges/types';
import {
  EDataType,
  NodeCategoryModel,
} from 'src/modules/network-configuration/models/node-data';
import { defaultPoE } from 'src/modules/network-configuration/nodes/standard-node/dialog-edit/edit-poe';
import {
  IConfigurationPoE,
  IConfigurationPoEInterface,
} from 'src/types/configuration';

import { getInfoConnected } from '../node';

export const configurationPoE = ({
  nodeId,
  edges,
  nodes,
  globalSettings,
}: {
  nodeId: string;
  edges: Edge[];
  nodes: Node[];
  globalSettings?: GlobalSettingsType;
}): IConfigurationPoE => {
  const poe: IConfigurationPoE = {
    interfaces: [],
    version: 2,
  };

  const targetNode = nodes.find((node) => node.id === nodeId);

  // all PoE ports on the target node
  const poePorts =
    (targetNode?.data?.category as NodeCategoryModel)?.ports?.filter(
      (port) => port.isPoE,
    ) || [];

  const interfaces: IConfigurationPoEInterface[] = poePorts.map((port) => {
    // get the device from the connectedDevices array

    const { node, edge } = getInfoConnected(nodeId, port.id, edges, nodes);
    const isUnused = !node;

    if (isUnused) {
      // For unused ports, use global settings
      const enable = globalSettings?.unusedPorts?.poe ?? false;
      return {
        enable,
        fault: defaultPoE.fault,
        limit: defaultPoE.limit,
        limit_pwr: defaultPoE.limit_pwr,
        name: '',
        prio: defaultPoE.prio,
      };
    }

    const connectedNodeCategory = node?.data?.category as NodeCategoryModel;
    const isDevice = connectedNodeCategory.type === EDataType.Device;
    if (!isDevice)
      return {
        enable: defaultPoE.enable,
        fault: defaultPoE.fault,
        limit: defaultPoE.limit,
        limit_pwr: defaultPoE.limit_pwr,
        name: '',
        prio: defaultPoE.prio,
      };

    const edgeData = edge?.data as IEdgeExtraData;

    const name = edgeData?.useCustomDescription
      ? edgeData?.customDescription || ''
      : connectedNodeCategory.name || '';

    const isEnable = connectedNodeCategory.poe?.enable || defaultPoE.enable;

    return {
      enable: isEnable,
      fault: connectedNodeCategory.poe?.fault || defaultPoE.fault,
      limit: connectedNodeCategory.poe?.limit || defaultPoE.limit,
      limit_pwr: connectedNodeCategory.poe?.limit_pwr || defaultPoE.limit_pwr,
      name: isEnable ? name : '',
      prio: connectedNodeCategory.poe?.prio || defaultPoE.prio,
    };
  });

  poe.interfaces = interfaces;

  return poe;
};
